import { DateTime } from "luxon";

import type { CalendarEvent, CalendarEventFilterQuery } from "../Models/Domain";

import { getCalendarsEvents } from "@/Services/TherapyApi/Calendars";
import CalendarEventTransformer from "@/Modules/Transformers/Calendars/Event";

import useCalendarsStore from "../Store";

import { hasValue } from "@/Utils/Objects";

const updateCalendarQueryActionHandler = async (
  newQuery: CalendarEventFilterQuery
): Promise<CalendarEvent[]> => {
  const calendarsStore = useCalendarsStore();
  const calls: Promise<CalendarEvent[]>[] = [];

  if (hasValue(newQuery.fromDate) && calendarsStore.query.fromDate! > newQuery.fromDate) {
    const fromDate = DateTime.fromSeconds(newQuery.fromDate).minus({ months: 2 }).toUnixInteger();

    calendarsStore.isLoadingMore = true;
    calls.push(
      getCalendarsEvents({
        from_date: fromDate,
        to_date: calendarsStore.query.fromDate,
      }).then((list) => list.map(CalendarEventTransformer.toDomain))
    );

    calendarsStore.query.fromDate = fromDate;
  }

  if (hasValue(newQuery.toDate) && calendarsStore.query.toDate! < newQuery.toDate) {
    const toDate = DateTime.fromSeconds(newQuery.toDate).plus({ months: 2 }).toUnixInteger();

    calendarsStore.isLoadingMore = true;
    calls.push(
      getCalendarsEvents({
        from_date: calendarsStore.query.toDate,
        to_date: toDate,
      }).then((list) => list.map(CalendarEventTransformer.toDomain))
    );

    calendarsStore.query.toDate = toDate;
  }

  if (calls.length > 0) {
    const events = await Promise.all(calls).then((list) => list.flat());

    calendarsStore.events = calendarsStore.events.concat(events);
  }

  calendarsStore.isLoadingMore = false;

  return calendarsStore.events;
};

export default updateCalendarQueryActionHandler;
